(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.Layer_Shapefile_Point = (function(superClass) {
    extend(Layer_Shapefile_Point, superClass);

    function Layer_Shapefile_Point() {
      this.refresh = bind(this.refresh, this);
      this.onSlider = bind(this.onSlider, this);
      Layer_Shapefile_Point.__super__.constructor.call(this);
      this.layoutSelector = null;
    }

    Layer_Shapefile_Point.prototype.onSlider = function(ev, ui) {
      return this.setOpacity(ui.value);
    };

    Layer_Shapefile_Point.prototype.init = function() {
      this.layer_id = this.loadLayoutPostOptions.id;
      return $.post('backend/grower/layers/shapefile/get-bounds-and-binning', {
        id: this.layer_id
      }, (function(_this) {
        return function(response) {
          if (_this.__destroyed) {
            return null;
          }
          _this.bounds = new L.LatLngBounds([[response.data.bounds.south, response.data.bounds.west], [response.data.bounds.north, response.data.bounds.east]]);
          _this.binning = response.data.binning;
          _this.infoWindow = new L.Popup();
          App.map.on('zoomend', _this.refresh);
          return _this.refresh();
        };
      })(this));
    };

    Layer_Shapefile_Point.prototype.refresh = function() {
      var url;
      if (App.map.getZoom() < 14) {
        return;
      }
      url = ((Config.get('gis_server')) + "/point-data-raster?id=" + this.layer_id + "&bin_attr=" + this.binning + "&zoom_level=") + App.map.getZoom();
      if (this.overlay != null) {
        App.map.removeLayer(this.overlay);
      }
      if (this._clickListener != null) {
        App.map.off('click', this._clickListener);
      }
      this.overlay = new L.ImageOverlay(url, this.bounds);
      this.overlay.addTo(App.map);
      L.DomUtil.addClass(this.overlay._image, 'clickable');
      this._clickListener = (function(_this) {
        return function(e) {
          if (!_this.bounds.contains(e.latlng)) {
            return;
          }
          App.map.closePopup(_this.infoWindow);
          return $.post('backend/grower/layers/shapefile/get-image-clicked-data', {
            id: _this.layer_id,
            lat: e.latlng.lat,
            lng: e.latlng.lng,
            sort_attr: _this.binning
          }, function(response) {
            var ref;
            if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
              return;
            }
            _this.infoWindow.setContent(response.view);
            _this.infoWindow.setLatLng([response.data.lat, response.data.lng]);
            return App.map.openPopup(_this.infoWindow);
          });
        };
      })(this);
      return App.map.on('click', this._clickListener);
    };

    Layer_Shapefile_Point.prototype.setOpacity = function(v) {
      if (this.overlay != null) {
        return this.overlay.setOpacity(parseFloat((v / 100).toFixed(2)));
      }
    };

    Layer_Shapefile_Point.prototype.destroy = function() {
      if (this.overlay != null) {
        App.map.removeLayer(this.overlay);
      }
      App.map.off('click', this._clickListener);
      App.map.off('zoomend', this.refresh);
      return Layer_Shapefile_Point.__super__.destroy.call(this);
    };

    return Layer_Shapefile_Point;

  })(Handler);

}).call(this);
